import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import ProteinActions from 'molbio/aa-sequences/AaSequenceActions';
import {Protein} from 'molbio/aa-sequences/util/AaSequenceConstants';
import notifications, {Response, ResponseJSON} from 'notifications';

type ProteinUpdateErrorResponse = Response & {responseJSON?: ResponseJSON & {updatedProtein?: Protein}};

/**
 * Error handler for any AA sequence DAO operations
 */
const handleProteinUpdateError = (e: ProteinUpdateErrorResponse): void => {
  // If the AA sequence was out of date, we'll get an error with the new AA sequence.
  const protein = e.responseJSON && e.responseJSON.updatedProtein;
  if (protein) {
    AppDispatcher.dispatch({
      actionType: EventConstants.PROTEIN_UPDATE_COMPLETED,
      proteinId: protein.id,
      newProtein: protein,
    });
    ProteinActions.fetchVersions(protein.id);
  }
  notifications.notifyError(e);
};

export default handleProteinUpdateError;
